import * as Sentry from '@sentry/react';

type ReactErrorInfo = { componentStack?: string | null };

export function captureReactError(error: unknown, info: ReactErrorInfo): void {
  Sentry.captureException(error, {
    contexts: {
      react: { componentStack: info.componentStack ?? undefined },
    },
  });
}
